import { render, staticRenderFns } from "./CamposPersonalizados.vue?vue&type=template&id=15e4eade"
import script from "./CamposPersonalizados.vue?vue&type=script&lang=js"
export * from "./CamposPersonalizados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports